import React, { memo, useEffect, useState, useRef } from 'react'
import { AnimatePresence } from 'framer-motion'
import CustomScroller from 'react-custom-scroller'

import useWindowResize from '../../hooks/useWindowResize'
import ServicesAccent from './ServicesAccent'

import {
  ServiceModalContainer,
  ServiceTitle,
  ServiceDescription,
  ServiceItems,
  ServiceItem,
  ServiceItemDescription,
  ServiceModalWrapper,
} from '../../styles/servicesStyles'

const ServiceModal = ({ service, isActive }) => {
  const windowSize = useWindowResize()
  const splitTitle = service.title.split(' ')

  const smodalScroller = useRef(null)

  const [openService, setOpenService] = useState('');

  const handleOpenService = (item, index) => {
    if ( item.description ) {
      if ( openService !== index ) {
        setOpenService(index);
      } else {
        setOpenService('');
      }
    }
  }

  useEffect(() => {
    if ( isActive ) {
      smodalScroller.current.scrollTop = 0
    }
  }, [isActive])
  return (
    <AnimatePresence exitBeforeEnter>
      {isActive && (
        <ServiceModalContainer
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 1,
            ease: 'easeOut',
          }}
          exit={{ opacity: 0 }}>
          { windowSize.width > 420 && (
            <ServicesAccent />
          )}
          <CustomScroller ref={smodalScroller} className='Scroller' innerClassName='ScrollerContent'>
            <ServiceModalWrapper
              initial={{
                opacity: 0,
                y: '30%',
              }}
              animate={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                default: {
                  duration: 1.5,
                  ease: 'easeOut',
                  delay: 0.5,
                },
                opacity: {
                  duration: 2,
                  ease: 'linear',
                  delay: 0.5,
                },
              }}>
              <ServiceTitle>
                <h3>
                  {splitTitle.map((word, index) => (
                    <span key={`modal-title-${word}-${index}`}>{word}</span>
                  ))}
                </h3>
                <p>{service.subtitle}</p>
              </ServiceTitle>
              <ServiceDescription
                dangerouslySetInnerHTML={{ __html: service.description }}
              />
              <ServiceItems>
                {service.services.map((item, index) => (
                  <ServiceItem
                    key={`service-item-${index}`}
                    className={item.description && `contentful`}
                  >
                    <h4 onClick={() => handleOpenService(item, index)}>
                      { item.icon && (
                        <span>
                          <img src={item.icon} alt={item.title} />
                        </span>
                      )}
                      {item.title}
                    </h4>
                    <AnimatePresence initial={false}>
                    { item.description && openService === index && (
                      <ServiceItemDescription
                        key={`item-description-${index}`}
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                          open: { opacity: 1, height: "auto" },
                          collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.5, ease: [0.04, 0.62, 0.23, 0.98] }}
                        dangerouslySetInnerHTML={{ __html: item.description }} />
                    )}
                    </AnimatePresence>      
                  </ServiceItem>
                ))}
              </ServiceItems>
            </ServiceModalWrapper>
          </CustomScroller>
        </ServiceModalContainer>
      )}
    </AnimatePresence>
  )
}

export default memo(ServiceModal)
